'use client'

import { compactClassName } from '@/components/homepage-october/compact'
import * as React from 'react'
import { ChevronLeft, ChevronRight } from '@/components/homepage-october/lucide'
import { cn } from '@/lib/utils'
import { useDragScroll } from '../hooks'

/** Native touch/wheel scrolling plus labelled buttons for keyboard users. */
export function HorizontalScroll({ label, children, className }: { label: string; children: React.ReactNode; className?: string }) {
  const viewport = React.useRef<HTMLDivElement>(null)
  const drag = useDragScroll(viewport)
  const id = React.useId()
  const [overflow, setOverflow] = React.useState(false)
  React.useEffect(() => {
    const el = viewport.current
    if (!el) return
    const measure = () => setOverflow(el.scrollWidth > el.clientWidth + 1)
    const observer = new ResizeObserver(measure)
    observer.observe(el)
    if (el.firstElementChild) observer.observe(el.firstElementChild)
    measure()
    return () => observer.disconnect()
  }, [children])
  const scroll = (direction: number) => viewport.current?.scrollBy({ left: direction * viewport.current.clientWidth * .8, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' })
  return <div>
    {overflow ? <div className={compactClassName("mb-2 flex justify-end gap-2")}>
      <button type="button" aria-label={`Scroll left: ${label}`} aria-controls={id} onClick={() => scroll(-1)} className={compactClassName("flex size-11 items-center justify-center rounded-full border bg-white")}><ChevronLeft aria-hidden="true" className="size-4" /></button>
      <button type="button" aria-label={`Scroll right: ${label}`} aria-controls={id} onClick={() => scroll(1)} className={compactClassName("flex size-11 items-center justify-center rounded-full border bg-white")}><ChevronRight aria-hidden="true" className="size-4" /></button>
    </div> : null}
    <div ref={viewport} {...drag} id={id} role="region" aria-label={label} className={compactClassName(cn('relative w-full overflow-x-auto', className))}>{children}</div>
  </div>
}
